/* eslint-disable no-multi-spaces */
import Vue            from 'vue'
import Router         from 'vue-router'
import home           from '@/components/page/home'
import news           from '@/components/page/news/news'
import newsList       from '@/components/page/news/news-list'
import newsArticle    from '@/components/page/news/news-article'
import story          from '@/components/page/story/story'
import storyIntroduction      from '@/components/page/story/story-introduction'
import storyArticle   from '@/components/page/story/story-article'
import character      from '@/components/page/character'
import staff          from '@/components/page/staff/staff'
import staffList      from '@/components/page/staff/staff-list'
import staffArticle   from '@/components/page/staff/staff-article'
import onair          from '@/components/page/onair'
import streaming      from '@/components/page/streaming'
import movie          from '@/components/page/movie'
import music          from '@/components/page/music'
import bd             from '@/components/page/bd/bd'
import bdArticle      from '@/components/page/bd/bd-article'
import goods          from '@/components/page/goods/goods'
import goodsList      from '@/components/page/goods/goods-list'
import goodsArticle   from '@/components/page/goods/goods-article'
import special        from '@/components/page/special/special'
import specialList    from '@/components/page/special/special-list'
import specialArticle from '@/components/page/special/special-article'
// import modal          from '@/components/view/modal'
/* eslint-enable */

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    /**
     * 画面遷移した時にスクロール位置をトップにするが一部ページではスクロール位置を保つ
     */
    if (to.name === 'home' && from.name === 'home') {
      return false
    } else if (to.name === 'staff-article' || from.name === 'staff-article') {
      return false
    } else if (to.name === 'raz-staff-article' || from.name === 'raz-staff-article') {
      return false
    } else if (to.name === 'movie' && from.name === 'movie') {
      return false
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: home,
      meta: {
        pageTitle: '「GREAT PRETENDER」公式サイト'
      }
    },
    {
      path: '/news',
      component: news,
      children: [
        {
          path: '/news',
          name: 'news',
          component: newsList,
          meta: {
            pageTitle: 'NEWS'
          }
        },
        {
          path: '/news/:newsId',
          name: 'news-article',
          component: newsArticle,
          props: true,
          meta: {
            collection: 'news',
            docId: 'newsId'
          }
        }
      ]
    },
    {
      path: '/story',
      component: story,
      children: [
        {
          path: '/story/introduction',
          name: 'story-introduction',
          component: storyIntroduction,
          meta: {
            pageTitle: 'INTRODUCTION'
          }
        },
        {
          path: '/story/:storyId',
          name: 'story-article',
          component: storyArticle,
          props: true,
          meta: {
            collection: 'story',
            docId: 'storyId'
          }
        },
        {
          path: '/razbliuto/story/:storyId',
          name: 'raz-story-article',
          component: storyArticle,
          props: true,
          meta: {
            collection: 'razstory',
            docId: 'storyId',
            version: 'raz'
          }
        }
      ]
    },
    {
      path: '/character/:characterId',
      name: 'character',
      component: character,
      props: true,
      meta: {
        collection: 'character',
        docId: 'characterId'
      }
    },
    {
      path: '/razbliuto/character/:characterId',
      name: 'raz-character',
      component: character,
      props: true,
      meta: {
        collection: 'razcharacter',
        docId: 'characterId',
        version: 'raz'
      }
    },
    {
      path: '/staffcast',
      component: staff,
      children: [
        {
          path: '/staffcast',
          name: 'staff',
          component: staffList,
          meta: {
            pageTitle: 'STAFF/CAST'
          },
          children: [
            {
              path: '/staffcast/:staffId',
              name: 'staff-article',
              component: staffArticle,
              props: true,
              meta: {
                collection: 'staff',
                docId: 'staffId'
              }
            }
          ]
        },
        {
          path: '/razbliuto/staffcast',
          name: 'raz-staff',
          component: staffList,
          meta: {
            pageTitle: 'STAFF/CAST',
            version: 'raz'
          },
          children: [
            {
              path: '/razbliuto/staffcast/:staffId',
              name: 'raz-staff-article',
              component: staffArticle,
              props: true,
              meta: {
                collection: 'razstaff',
                docId: 'staffId',
                version: 'raz'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/streaming',
      name: 'streaming',
      component: streaming,
      meta: {
        pageTitle: 'STREAMING'
      }
    },
    {
      path: '/onair',
      name: 'onair',
      component: onair,
      meta: {
        pageTitle: 'ONAIR'
      }
    },
    {
      path: '/movie',
      name: 'movie',
      component: movie,
      meta: {
        pageTitle: 'MOVIE'
      }
    },
    {
      path: '/music',
      name: 'music',
      component: music,
      meta: {
        pageTitle: 'MUSIC'
      }
    },
    {
      path: '/bd',
      component: bd,
      children: [
        {
          path: '/bd/:bdId',
          name: 'bd',
          component: bdArticle,
          props: true,
          meta: {
            collection: 'bd',
            docId: 'bdId'
          }
        }
      ]
    },
    {
      path: '/goods',
      component: goods,
      children: [
        {
          path: '/goods',
          name: 'goods',
          component: goodsList,
          meta: {
            pageTitle: 'GOODS'
          }
        },
        {
          path: '/goods/:goodsId',
          name: 'goods-article',
          component: goodsArticle,
          props: true,
          meta: {
            collection: 'goods',
            docId: 'goodsId'
          }
        }
      ]
    },
    {
      path: '/special',
      component: special,
      children: [
        {
          path: '/special',
          name: 'special',
          component: specialList,
          meta: {
            pageTitle: 'SPECIAL'
          },
          children: [
            {
              path: '/special/:specialId',
              name: 'special-article',
              component: specialArticle,
              props: true,
              meta: {
                collection: 'special',
                docId: 'specialId'
              }
            }
          ]
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js